<template>
  <view-container title="Bestiary">
    <template v-slot:heading>
      <span>Monster templates</span>
    </template>

    <template v-slot:default>
      <bestiary-search-form />

      <div>
        <item-animator
          :items="filteredMonsters"
          class="mt-6"
          data-test="bestiaryList"
        >
          <template v-slot="item">
            <bestiary-item :item="item" class="opacity-100" />
          </template>
        </item-animator>
      </div>
    </template>

    <template v-slot:after>
      <router-link
        :to="{ name: `home` }"
        class="py-4 inline-block"
        v-if="battle"
      >
        Back&#160;to&#160;battle
      </router-link>
    </template>
  </view-container>
</template>

<script>
import BestiaryItem from '@/components/BestiaryItem'
import BestiarySearchForm from '@/components/BestiarySearchForm'
import ItemAnimator from '@/components/ItemAnimator'
import ViewContainer from '@/components/ViewContainer'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: `BestiaryView`,

  components: {
    BestiaryItem,
    BestiarySearchForm,
    ItemAnimator,
    ViewContainer,
  },

  computed: {
    ...mapGetters(`battles`, [`battle`]),
    ...mapGetters(`bestiary`, [`loading`, `filteredMonsters`]),
  },

  methods: {
    ...mapActions(`bestiary`, [`setAllMonsters`]),
  },

  created() {
    this.setAllMonsters()
  },
}
</script>
